import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/resume/${url}`, ...arg)
/**
 * 用户简历接口管理
 *
 */
export default {
	// 分页
	resumePage(data) {
		return request('page', data, 'get')
	},
	// 详情
	resumeDetail(data) {
		return request('detail', data, 'get')
	},
	// 提交表单 edit为true时为编辑，默认为新增
	submitForm(data, id) {
        return request(id ? 'edit' : 'add', data)
	},
	// 删除
	resumeDelete(data) {
		return request('delete', data)
	},
	// 仅企业查看，并可只查看公开简历
	complexResume(data) {
		return request('complexResume', data, 'get')
	},
	// 切换用户简历公开状态
	resumeSwitchDisplay(data) {
		return request('switchDisplay', data)
	},
	// 获取简历隐私设置详情
	complexResumeView(data) {
		return request('complexApplyResumeView', data, 'get')
	},
	// 个人端-查看自己简历
	userResumeView(data) {
		return request('userResumeView',data, 'get')
	}
}
